module.exports = __webpack_public_path__ + "img/delete.4eb0ea25.svg";